import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, BUTTON_TYPE } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';
import { StyledTitles, StyledWrapper } from '~/pages/HomePage/components/design-your-qr-code/styled';
import { getIsDesktop } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

export default function DesignYourQrCode() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isDesktop = useSelector(getIsDesktop);

  const handleSignUp = () => {
    navigate(PATH.SIGN_UP);
  };

  return (
    <StyledWrapper>
      <div className="mobile-left-qr" />
      <div className="mobile-right-qr" />
      <StyledTitles>
        <Text variant={isDesktop ? 'h1.5' : 'h2'} sx={{ color: COLORS.white, textAlign: 'center' }}>
          {t('landing:designYourCode.title')}
        </Text>
        <Text variant={'h2'} sx={{ color: COLORS.white, textAlign: 'center' }}>
          {t('landing:designYourCode.generate')}
        </Text>
      </StyledTitles>
      <Button
        type={BUTTON_TYPE.contained}
        backgroundColor={COLORS.white}
        color={COLORS.primary}
        hoverBackgroundColor={COLORS.white}
        onClick={handleSignUp}
      >
        {t('landing:createFreeAccount')}
      </Button>
    </StyledWrapper>
  );
}
